import { render, staticRenderFns } from "./ClickableCard.vue?vue&type=template&id=77aca37d&scoped=true&"
import script from "./ClickableCard.vue?vue&type=script&lang=js&"
export * from "./ClickableCard.vue?vue&type=script&lang=js&"
import style0 from "./ClickableCard.vue?vue&type=style&index=0&id=77aca37d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aca37d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardActions,VCardText,VHover,VListItem})
